<template>
  <div v-if="active" class="dialog-backdrop">
      <div class="dialog-container" >
         <button class="btn-close" @click="$emit('close')">はい</button>
        <div class="message" ><slot /></div>
      </div>
    </div>
</template>

<script>

export default {
  name: "Image",
  props: {
    active: { type: Boolean, default: false },
  },
  emits: ['close'],
};
</script>

<style scoped>
.dialog-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;
}

.dialog-container {
  max-width: 768px;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  width: 80%;
}

.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s;
}
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .dialog-container,
.dialog-leave-active .dialog-container {
  transition: transform 0.4s;
}
.dialog-enter .dialog-container,
.dialog-leave-to .dialog-container {
  transform: scale(0.9);
}
.btn-close {
  color: #33a8ee;
  border: none;
  outline: none;
  background: none;
  padding-bottom: 15px;
}
</style>